module.exports = __webpack_public_path__ + "static/media/error2.0c24fe70.svg";